<template>
  <div>
    <v-dialog v-model="showDlg" max-width="600" persistent>
      <div class="primary white--text pa-3 title">
        <span v-if="isNewComm">New community creation</span>
        <span v-else>Joining to {{commNm}}</span>
      </div>
      <v-stepper v-model.number="curStep">
        <v-stepper-header>
          <v-stepper-step step="1" :complete="curStep > 1">Mobile validation</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="curStep > 2">Personal details</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="curStep > 3">{{isNewComm ? 'Community details' : 'Unit details' }}</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4">Done</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content class="pl-0 pr-0" step="1">
            <v-card flat>
              <v-card-title class="title pt-0">Mobile validation</v-card-title>
              <v-card-text class="py-0">
                <v-form ref="form1">
                  <v-container class="pa-0" grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <vue-tel-input-vuetify
                        ref="refMob"
                        v-model="mobile"
                        label=""
                        placeholder="Enter a mobile number"
                        @keydown.native="ignoreBackspace"
                        @input="keepCursor"
                        :rules="[rules.required]"
                        :input-options="{showDialCode: true}"
                        @validate="validateMob"
                        />
                        <div class="caption grey--text">
                          Enter your mobile number and press send OTP
                        </div>
                        <div class="text-xs-right">
                          <span v-if="secToWait > 0" class="caption grey--text">Wait {{secToWait}} sec to retry</span>
                          <v-btn flat class="ma-0 pa-0 accent--text" @click="sendOTP"
                          :disabled="(!canResend && !isValidNumber) || secToWait > 0"
                          >
                          {{(canResend ? 'Resend' : 'Send') + ' OTP'}}
                        </v-btn>
                      </div>
                    </v-flex>
                    <v-flex xs12 v-if="isOTPSent">
                      <v-text-field
                      v-model.trim="otp" class="pt-0"
                      type="number"
                      placeholder="Enter OTP"
                      hide-details
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 v-if="isOTPSent" class="mt-4">
                      By clicking continue, you agree to our <a class="info--text" @click="showTerms=true">terms & conditions and privacy policy</a></v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </v-card-text>
            </v-card>
          </v-stepper-content>
          <v-stepper-content class="pl-0 pr-0" step="2">
            <v-card flat scrollable>
              <v-card-title class="title pt-0">Personal details</v-card-title>
              <v-card-text class="py-0">
                <v-form ref="form2">
                  <v-container class="pa-0" grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12 v-if="isHavingHistory">
                        <v-alert color="warning" value="true" class="mt-0">
                          <div class="mb-2">
                            You already have below accounts with us, continue if you wish to join another unit.
                          </div>
                          <div v-for="(unit,u) in userHistory" :key="u" class="primary--text">
                            <span v-if="unit.unit_no">
                              {{ u+1 + '. ' + unit.block_nm + ' ' + unit.unit_no + ' in ' + unit.comm_name }}
                            </span>
                            <span v-else-if="unit.comm_name"> <!-- could be FM -->
                              {{ unit.role_name + ' in ' + unit.comm_name }}
                            </span>
                          </div>
                        </ul>
                      </v-alert>
                    </v-flex>
                    <v-flex xs7 class="mt-2">
                      <v-text-field
                      v-model.trim="name" class="pt-0" placeholder="Your name"
                      :rules="[rules.required]"
                      maxlength="50"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs5 class="mt-2">
                      <v-select class="pt-0" v-model="gender"
                      :items="['Male', 'Female']"
                      placeholder="Gender"
                      :rules="[rules.required]"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-text-field
                      v-model.trim="email" class="pt-0" placeholder="E-mail address"
                      :rules="[rules.required, rules.email]"
                      maxlength="50"
                      ></v-text-field>

                      <v-checkbox label="Hide contact info from others"
                      v-model="hideContact" :disabled="mcOrOthers !== 'resident'"
                      hint="Not possible if you are part of association or staff ;)"
                      persistent-hint
                      ></v-checkbox>
                    </v-flex>
                    <v-flex xs12>
                      <v-radio-group
                      v-model="mcOrOthers"
                      class="pa-0"
                      hide-details

                      >
                      <v-radio label="Resident (owner/tenant)"
                      value="resident"
                      ></v-radio>
                      <v-radio :label="(commCountryCode === 'MY' ? 'JMB' : 'Association') + '/MC member'"
                      value="mc-member"
                      ></v-radio>
                      <v-radio label="Staff"
                      value="staff"
                      ></v-radio>
                      <v-radio label="Others"
                      value="other-user"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs12 v-if="mcOrOthers !== 'resident'">
                    <v-select class="pa-0" v-model="role"
                    placeholder="Role"
                    :items="mcOrOthers === 'mc-member'?mcRolesList:(mcOrOthers === 'staff'?staffRolesList:othersRolesList)"
                    :rules="[rules.required]"
                    ></v-select>
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-stepper-content>
    <v-stepper-content class="pl-0 pr-0" step="3">
      <v-card flat>
        <v-card-title v-if="isNewComm" class="title pt-0">Community details</v-card-title>
        <v-card-text class="py-0">
          <v-form ref="form3">
            <v-container class="pa-0" grid-list-md>
              <v-layout row wrap v-if="!isNewComm">
                <v-flex xs12 class="text-xs-center">
                  <v-chip disabled class="title accent white--text pa-2">
                    <v-icon color="white" class="mr-2" large>location_city</v-icon>
                    {{ commNm }}
                  </v-chip>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-else>
                <v-flex xs12>
                  <v-text-field
                  ref="refCommName"
                  v-model.trim="commNm" class="pt-0" placeholder="Community name"
                  :rules="[rules.required]"
                  hint="New community will be created with this name"
                  persistent-hint
                  @blur="checkDupComm"
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                  v-model.trim="commAdr" class="pt-0" placeholder="Address"
                  :rules="[rules.required]" hide-details
                  maxlength="50"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model.trim="commCity" class="pt-0" placeholder="City"
                  :rules="[rules.required]" hide-details
                  maxlength="25"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model.trim="commPIN" class="pt-0" placeholder="PIN"
                  :rules="[rules.required]" hide-details
                  maxlength="10"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field
                  v-model.trim="commState" class="pt-0" placeholder="State"
                  :rules="[rules.required]" hide-details
                  maxlength="25"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-select
                  v-model.trim="commCountry"
                  :items="config.SUPPORTED_COUNTRIES.map(rec => rec.country)"
                  class="pt-0"
                  placeholder="Country"
                  hide-details
                  maxlength="50"
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="mcOrOthers !== 'staff' && mcOrOthers !== 'other-user'">
                <v-flex xs12>
                  <div class="title pt-4 pb-2">Unit details</div>
                </v-flex>
                <v-flex xs6>
                  <v-combobox
                  v-model.trim="blockNm"
                  placeholder="Block"
                  :items="blockList"
                  :rules="[rules.required]"
                  maxlength="25"
                  @input="findBlockId()"
                  :disabled="cantChangeUnit"
                  >
                </v-combobox>
              </v-flex>
              <v-flex xs6>
                <v-combobox
                placeholder="Unit no."
                v-model.trim="unitNo"
                :rules="[rules.required]"
                :items="unitList"
                maxlength="10"
                @input="findUnitId()"
                :disabled="cantChangeUnit"
                ></v-combobox>
              </v-flex>
              <v-flex xs12>
                <v-select
                class="pt-0" v-model="ownership"
                :items="resRolesList"
                placeholder="Ownership"
                :rules="[rules.required]"
                :disabled="cantChangeUnit"
                >
              </v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card-text>
  </v-card>
</v-stepper-content>
<v-stepper-content step="4">
  <v-card flat class="text-xs-center">
    <v-icon x-large color="primary">auto_awesome</v-icon>
    <div class="headline">Congrats!<br/>You are now part of<br /></div>
    <v-chip disabled class="title accent white--text pa-2">
      <v-icon color="white" class="mr-2" large>location_city</v-icon>
      {{ commNm }}
    </v-chip>
    <v-alert outline color="info" :value="true" class="mt-3 pa-1 text-xs-center">
      <span v-if="isVerResident && !isAdmin">Your resident identity verified successfully. You can start using the app right away!</span>
      <span v-else-if="!isAdmin">You will be notified as soon as your community admin accepts your request</span>

      <span v-else>
        IMPORTANT
        <br /><br />
        As your community is just beginning to grow up in Uniservice, you will be one of 3 admins until a committee takes it over.
        <br /><br />
        Till then, you will be notified to approve whenever other users wish to join your community.
      </span>
    </v-alert>
  </v-card>
</v-stepper-content>
<!-- action buttons -->
<v-container class="pa-0 primary">
  <v-layout row wrap>
    <v-flex xs2>
      <v-btn flat class="text-xs-left white--text" v-if="curStep > 1 && curStep < 4"@click.native="prevStep" icon><v-icon>arrow_back</v-icon></v-btn>
    </v-flex>
    <v-spacer></v-spacer>
    <v-btn flat class="white--text" v-if="curStep < 4" @click.stop="closeDlg">Cancel</v-btn>
    <v-btn flat class="accent--text" v-if="curStep == 4"@click.stop="closeDlg">Close</v-btn>
    <v-btn flat class="text-xs-right accent--text" v-if="curStep < 4"@click.native="nextStep" :disabled="beingSaved"><b>{{ butCap }}</b></v-btn>
  </v-layout>
</v-container>
</v-stepper-items>
</v-stepper>
</v-dialog>

<v-dialog v-model="showSimComm" max-width="400px" persistent scrollable>
  <v-card flat>
    <v-card-title class="title">
      Wait!
    </v-card-title>
    <v-card-text>
      <span class="subheading">{{similarCommList.length > 1 ? 'Communities' : 'Community'}} with similar name already found.<br /><br />Please tap on your community listed below or tap on OVERRIDE to proceed with the name you entered.</span>
      <v-data-table
      :headers="commNameHead"
      :items="similarCommList"
      disable-initial-sort
      hide-actions
      >
      <template slot="items" slot-scope="props">
        <tr @click="chooseComm(props.item)">
          <td class="text-xs-center"><span class="title info--text">{{ props.item.comm_name }}</span></td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
  <v-card-actions>
    <v-spacer></v-spacer>
    <v-btn flat @click="showSimComm = false">Close</v-btn>
    <v-btn flat @click="showSimComm = false">Overide & Use I Entered</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

<v-dialog v-model="showTerms" max-width="600px" persistent scrollable>
  <v-card flat scrollable>
    <v-card-title class="title">
      Terms & Conditions and Privacy Policy
      <v-btn style="position:absolute; top:7px; right:7px" small icon @click.native="showTerms = false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text>
      <div class="subheader py-2 primary--text">
        WHAT INFORMATION WE COLLECT
      </div>
      <ul class="ml-3">
        <li>
          Details about your society like name, address, number of blocks, flats and facilities.
        </li>
        <li>
          Personal information like name and contact details of management committee and residents.
        </li>
        <li>
          Personal information like name and contact number of visitors as a security measure of your society.
        </li>
        <li>
          Any other information which users share on their sole discretion while creating Invites/EasyPasses, posting notices, posts, comments, replies and complaints, etc.
        </li>
        <li>
          Invoice and payment details of maintenance & amenity booking charges. We do NOT store users' bank or card details.
        </li>
      </ul>
      <div class="subheader py-2 primary--text">
        WHAT DO WE USE YOUR INFORMATION FOR
      </div>
      <ul class="ml-3">
        <li>
          We (“Uniservice”) do NOT sell, rent or share any information collected above to any of our partners and/or third party, without your explicit approval.
        </li>
        <li>
          All information is protected with most care using stringent access control and encryption technologies both at transit and storage.
        </li>
        <li>
          The information we collect will be used only to provide you better and uninterrupted service by monitoring the usage & performance of the application, identify the gaps and improve our quality of service. Also by our support personal to review and respond to your tickets if any.
        </li>
      </ul>
      <div class="subheader py-2 primary--text">
        YOUR RIGHT ON YOUR DATA
      </div>
      <p class="mb-0">
        You can have all your personal information deleted from our systems if you are no longer associated to your society, with an intimation/permission of respective resident welfare association. Please contact us at postman@uniservice.in whenever you want to do so.
      </p>
      <div class="subheader py-2 primary--text">
        YOUR CONSENT
      </div>
      <p class="mb-0">
        By using our application, you consent to this privacy policy and terms & conditions.
      </p>
      <div class="subheader py-2 primary--text">
        NOTIFICATION OF CHANGES
      </div>
      <p>
        Any change made to these terms will be notified via E-mail and/or while logging in to application.
      </p>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- snack bar for error reporting -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="4000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

</div>
</template>

<script>
import config from '@/config/app-cfg'
import { login, getUserDevId } from '@/utils/auth'
import handy from '@/utils/handy'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'

export default {
  components: {
    'vue-tel-input-vuetify': VueTelInputVuetify
  },
  data () {
    return {
      config: config,
      showDlg: true,
      curStep: 0,
      commNm: this.comm,
      commId: '',
      commAdr: '',
      commCity: '',
      commPIN: '',
      commState: '',
      commCountry: this.country,
      commCountryCode: this.countrycode,
      isNewComm: this.comm === '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      butCap: 'Continue',
      rules: handy.rules,
      beingSaved: false,
      // step 1
      mobile: null,
      phone_country: null,
      isValidNumber: false,
      isOTPSent: false,
      otp: '',
      custId: '',
      userId: '',
      userHistory: [],
      isHavingHistory: false,
      cantChangeUnit: false,
      showTerms: false,
      canResend: false,
      secToWait: 0,
      timer: null,
      // step 2
      name: '',
      gender: '',
      email: '',
      mcOrOthers: 'resident',
      role: '',
      hideContact: false,
      isAdmin: true,
      roles: [],
      resRolesList: [],
      mcRolesList: [],
      staffRolesList: [],
      othersRolesList: [],
      // step 3
      blockId: '',
      blockList: [],
      blockNm: '',
      unitId: '',
      unitList: [],
      unitNo: '',
      ownership: '',
      isVerResident: false,
      isDuplicateUnit: false,
      showSimComm: false,
      justFocusIn: false,
      similarCommList: [],
      commNameHead: [
        { text: 'Existing Community', value: 'comm_name', class: 'text-xs-center' }
      ],
      // step 4
      regStatus: false
    }
  },
  props: ['comm', 'country', 'countrycode'],
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    closeDlg () {
      this.showDlg = false
      this.$emit('closed')
      // re-route to home page if successfully signed up
      if (this.curStep === 4) {
        this.$router.go('/')
      }
    },
    prevStep () {
      this.curStep--
      this.butCap = 'Continue'
    },
    nextStep () {
      // validate current form and move on
      switch (this.curStep) {
        case 1: {
          if (!this.isValidNumber) {
            this.msg('Invalid mobile number')
            return
          }
          // validate form
          if (this.$refs.form1.validate()) {
            // validate OTP
            this.axios.post(config.API_URL + '/otp/verify', {contact_phone: this.mobile, purpose: 'joining', otp: this.otp})
            .then(response => {
              this.findUserHistory()
              this.curStep++
            })
            .catch(err => {
              this.msg(err.response.data)
              return
            })
          }
          break
        }
        case 2: {
          if (this.$refs.form2.validate()) {
            this.butCap = 'Submit'
            this.curStep++
          } else {
            return
          }
          break
        }
        case 3: {
          if ((this.$refs.form3.validate() && !this.isDuplicateUnit) || (this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user')) {
            // block and unit validation
            if (!this.isNewComm && this.mcOrOthers !== 'staff' && this.mcOrOthers !== 'other-user' && (!this.blockId || !this.unitId)) {
              this.msg('Choose block and unit from existing list')
              return
            }
            // derive the role
            var relStatusIfOthers = null

            if (this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user') {
              relStatusIfOthers = this.isAdmin ? 'Linked' : 'Pending Approval'
              this.isVerResident = false
            } else if (this.mcOrOthers === 'resident') {
              this.role = this.ownership
            }

            // create account
            var user = {
              'cust_name': this.name,
              'cust_id': this.custId,
              'comm_name': this.commNm,
              'comm_id': this.commId,
              'address': this.commAdr,
              'city': this.commCity,
              'pin_code': this.commPIN,
              'state': this.commState,
              'country': this.commCountry,
              'country_code': this.commCountryCode,
              'contact_phone': this.mobile,
              'phone_country': this.phone_country,
              'contact_email': this.email,
              'is_mc_member': this.mcOrOthers === 'mc-member',
              'is_other_user': (this.mcOrOthers === 'staff' || this.mcOrOthers === 'other-user'),
              'is_admin': this.isAdmin,
              'role_name': this.role,
              'role_id': this.roles.find(rec => rec.role_name === this.role).role_id,
              'rel_status_if_other_user': relStatusIfOthers,
              'gender': this.gender,
              'hide_contact': this.hideContact,
              'block_id': this.blockId,
              'block_nm': this.blockNm,
              'unit_id': this.unitId,
              'unit_no': this.unitNo,
              'ownership': this.ownership,
              'rel_status': !this.isAdmin && !this.isVerResident ? 'Pending Approval' : 'Linked',
              'reg_mode': 'WEB',
              'user_id': this.userId,
              'is_ver_resident': this.isVerResident,
              'is_self_service': true,
              'user_device_id': getUserDevId()
            }
            this.beingSaved = true
            this.axios.post(config.API_URL + '/resident/create', user)
            .then(response => {
              this.regStatus = true
              // keep logged in
              login(response.data.user_id, this.mobile, response.data.api_key)

              // delete the temporary joinee record
              this.axios.post(config.API_URL + '/otp/delete-joinee', {contact_phone: this.mobile})

              this.curStep++
              this.beingSaved = false
            })
            .catch(err => {
              this.msg(err.response.data)
              this.beingSaved = false
            })
          } else {
            return
          }
          break
        }
      }
    },
    sendOTP () {
      this.mobile = this.mobile.replace(/ /g, '')
      if (!this.isValidNumber) {
        this.msg('Invalid mobile number')
        return
      }
      this.mobile = this.mobile.substring(0, 15)
      // send otp
      this.axios.post(config.API_URL + '/otp/send', {contact_phone: this.mobile, purpose: 'joining', country_code: this.commCountryCode})
      .then(response => {
        this.msg('An OTP is sent to your mobile. Please check and enter here', 2)
        // enable resend after few sec
        this.isOTPSent = true
        this.canResend = false
        this.secToWait = 30
        if (this.timer) {
          clearInterval(this.timer)
        }
        this.timer = setInterval(() => {
          this.secToWait--
          if (!this.secToWait) {
            clearInterval(this.timer)
            this.canResend = true
          }
        }, 1000)
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    findUserHistory () {
      this.mobile = this.mobile.replace(/ /g, '')
      // validate for fresh user
      this.custId = ''
      this.userId = ''
      this.name = ''
      this.gender = ''
      this.email = ''
      this.userId = ''
      this.isHavingHistory = false
      var qry = {
        params: {
          contact_phone: this.mobile
        }
      }
      this.axios.get(config.API_URL + '/getUserHistoryByPhone/', qry)
      .then(response => {
        if (response.data.length > 0) {
          this.userHistory = response.data
          if (this.userHistory.findIndex(rec => rec.unit_id) >= 0 || this.userHistory.findIndex(rec => rec.is_other_user) >= 0) {
            // re-use the customer details exist in uniapp
            this.custId = response.data[0].cust_id
            this.name = response.data[0].cust_name
            this.gender = response.data[0].gender
            this.email = response.data[0].contact_email

            var uIdx = this.userHistory.findIndex(rec => rec.user_id)
            if (uIdx >= 0) {
              this.userId = response.data[uIdx].user_id
              this.isHavingHistory = true
            } else {
              // resident record uploaded by MC and user just validating it
              this.blockId = response.data[0].block_id
              this.blockNm = response.data[0].block_nm
              this.unitId = response.data[0].unit_id
              this.unitNo = response.data[0].unit_no
              this.ownership = response.data[0].ownership
              this.cantChangeUnit = true
              this.isVerResident = true
            }
          } else {
            // customer already exist in backbone might be an on call customer. Just use customer id, do not expose other details, let customer enter it
            this.custId = response.data[0].cust_id
          }
        } else {
          this.userHistory = []
        }
      })
    },
    loadBlocks () {
      var qry = {
        params: {
          comm_id: this.commId
        }
      }
      this.axios.get(config.API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blocks = response.data
        this.blockList = this.blocks.map(rec => rec.block_nm)
        if (this.blockId) {
          this.loadUnits()
        } else {
          this.unitList = []
        }
      })
      .catch(err => {
        this.blocks = []
        this.blockList = []
        this.msg(err.response.data)
      })
    },
    loadUnits () {
      var qry = {
        params: {
          block_id: this.blockId
        }
      }
      this.axios.get(config.API_URL + '/getUnitsByBlockId/', qry)
      .then(response => {
        this.units = response.data
        this.unitList = this.units.map(rec => rec.unit_no)
      })
      .catch(err => {
        this.unitList = []
        this.msg(err.response.data)
      })
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: this.commId
        }
      }
      this.axios.get(config.API_URL + '/getRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
        this.resRolesList = this.roles.filter(rec => (rec.role_type === 'Resident')).map(rec => rec.role_name)
        this.mcRolesList = this.roles.filter(rec => (rec.role_type === 'RWA' && rec.role_name !== 'Administrator')).map(rec => rec.role_name)
        this.staffRolesList = this.roles.filter(rec => rec.role_type === 'Staff').map(rec => rec.role_name)
        this.othersRolesList = this.roles.filter(rec => (rec.role_type === 'Others')).map(rec => rec.role_name)
      })
      .catch(err => {
        this.roles = []
        this.resRolesList = []
        this.mcRolesList = []
        this.staffRolesList = []
        this.othersRolesList = []
        this.msg(err.response.data)
      })
    },
    findBlockId () {
      if (this.blocks && this.blockNm) {
        var idx = this.blocks.findIndex(rec => rec.block_nm === this.blockNm)
        if (idx >= 0) {
          this.blockId = this.blocks[idx].block_id
          this.loadUnits()
        } else {
          this.blockId = ''
          this.unitList = []
        }
      }
    },
    findUnitId () {
      this.isDuplicateUnit = false
      this.isVerResident = false
      if (this.units && this.unitNo) {
        var idx = this.units.findIndex(rec => rec.unit_no === this.unitNo)
        if (idx >= 0) {
          this.unitId = this.units[idx].unit_id

          // validate if the user already exist for this unit
          if (this.userHistory) {
            var existUser = this.userHistory.find(rec => rec.comm_id === this.commId && rec.unit_id === this.unitId)
            if (existUser) {
              if (existUser.user_id) {
                this.msg('You are already associated to this unit. Please login instead of joining again')
                this.isDuplicateUnit = true
              } else {
                // user already associated to this unit may be by MC, but user just signing up in app
                this.isVerResident = true
              }
            }
          }
        } else {
          this.unitId = ''
        }
      }
    },
    chooseComm (curComm) {
      this.commNm = curComm.comm_name
      this.loadComm()
      this.isNewComm = false
      this.showSimComm = false
    },
    loadComm () {
      if (this.commNm) {
        var qry = {
          params: {
            comm_name: this.commNm
          }
        }
        // find comm id
        this.axios.get(config.API_URL + '/getCommByName/', qry)
        .then(response => {
          if (response.data.length) {
            this.commId = response.data[0].comm_id
            // user retain same address as community by default
            this.commAdr = response.data[0].address
            this.commCity = response.data[0].city
            this.commPIN = response.data[0].pin_code
            this.commState = response.data[0].state
            this.commCountry = response.data[0].country
            // find no. of users & set currently registered user as admin if he is the first 3 users
            this.axios.get(config.API_URL + '/getUserCountByCommId/' + this.commId)
            .then(response => {
              if (response.data[0].total_user < 3) {
                this.isAdmin = true
              } else {
                this.isAdmin = false
              }
            })
            // load available roles
            this.loadRoles()
            // load available blocks
            this.loadBlocks()
          }
        })
      } else {
        // load default roles
        this.commId = 0
        this.loadRoles()
      }
    },
    checkDupComm () {
      // check for communities with similar names
      if (this.commNm) {
        var qry = {
          params: {
            comm_name: this.commNm
          }
        }
        // find comm id
        this.similarCommList = []
        this.axios.get(config.API_URL + '/getSimilarCommByName/', qry)
        .then(response => {
          if (response.data.length > 0) {
            this.similarCommList = response.data
            this.showSimComm = true
          }
        })
        .catch(err => {
          this.msg(err.response.data)
        })
      }
    },
    ignoreBackspace (e) {
      if (e.key === 'Backspace') {
        const start = this.mobile.length - 1
        this.mobile = this.mobile.substring(0, start)
        e.preventDefault()
      }
    },
    keepCursor () {
      this.$refs.refMob.cursorPosition = this.mobile.length
    },
    validateMob ({ number, valid, country }) {
      this.isValidNumber = valid
      if (valid) {
        this.mobile = number.e164
        this.phone_country = country.name && country.name.includes('(') ? country.name.substring(0, country.name.indexOf('(') - 1) : country.name
      }
    }
  },
  mounted () {
    this.loadComm()
  }
}
</script>



// WEBPACK FOOTER //
// JoinComm.vue?9376b178